import PropTypes from "prop-types";
import React from "react";
import {
  StyleSheet,
  View,
  TouchableOpacity,
  UIManager,
  Platform,
  Animated,
  ActivityIndicator,
} from "react-native";
import ENV from "app/utils/ENV";
import Text from "app/components/Text";
import apiActions from "app/utils/apiActions";
import textHelpers from "app/utils/textHelpers";
import colorHelpers from "app/utils/colorHelpers";
import valueHelpers from "app/utils/valueHelpers";
import frequencyHelpers from "app/utils/frequencyHelpers";
import * as RootNavigation from "app/utils/RootNavigation.js";
import { styleSheet, colors, sizes, screenRatio } from "app/utils/styleSheet";

import ProgressRing from "app/components/ProgressRing";
import QuickActions from "app/components/QuickActions";
import Icon from "app/components/Icon";
import { Feather, FontAwesome } from "@expo/vector-icons";
import TimelineNodes from "app/components/TimelineNodes";
import ValueInspector from "app/components/ValueInspector";
import List from "app/components/List";

import { TouchableOpacity as RNGHTouchableOpacity } from "react-native-gesture-handler";
const isAndroid = Platform.OS === "android";
if (isAndroid && UIManager.setLayoutAnimationEnabledExperimental) {
  UIManager.setLayoutAnimationEnabledExperimental(true);
}
const PlatformTouchable = isAndroid ? TouchableOpacity : TouchableOpacity;

export default class ButtonBadge extends React.Component {
  static propTypes = {
    value: PropTypes.object.isRequired,
    onPress: PropTypes.func,
  };

  static defaultProps = {
    scale: 1.0,
    scale: 0.5,
    iconScale: 1.0,
  };

  constructor(props) {
    super(props);
    this.state = {
      showQuickActions: false,
      showTimeline: false,
      showParents: false,
      loading: false,
      // scaleAnim: new Animated.Value(props.scale),
    };
  }

  render() {
    let {
      value,
      onPress,
      onLongPress,
      style,
      onUpdate,
      backgroundColor,
      scale,
      iconScale,
      noIcon,
      minWidth,
      condensed,
      showDueDate,
    } = this.props;

    let color = backgroundColor || valueHelpers.getColor(value);
    let darkenBy = colors.darkenBy;
    let darkenedColor = valueHelpers.iconColor(value, color).color;
    return (
      <View
        style={{
          minWidth,
          flex: -1,
          flex: 1,
        }}
      >
        {showParents && this.renderParents(value)}

        <PlatformTouchable
          simultaniousHandlers
          ref={(ref) => {
            this.ref = ref;
          }}
          // onPress={() => {
          //   if(!!onPress) onPress()
          //   else this.setState({showQuickActions: true})
          // }}
          // onLongPress={onLongPress}
          onPress={this.handlePress}
          onLongPress={() => {
            this.setState({ showQuickActions: true });
          }}
          style={[
            styles.wrapper,
            // {backgroundColor: ENV.DARK ? colors.darkest : colors.trim},
            // {backgroundColor: colors.darkest},
            !!dueIn && dueIn > 0 && { opacity: 0.6 },
            showParents && { paddingLeft: sizes.large * 2 },
            style,
          ]}
        >
          <View pointerEvents={this.props.pointerEvents}>
            <View
              style={{
                ...StyleSheet.absoluteFillObject,
                backgroundColor: color || undefined,
                backgroundColor: darkenedColor,
                borderRadius: sizes.small,
                //opacity: ENV.DARK ? 0.3 : 0.75,
                // opacity: 0.5,
                //opacity: iconOpacity,
              }}
            />

            <Animated.View
              style={[
                styles.row,
                {
                  // paddingVertical: sizes.large*2 *scaleAnim,
                  paddingVertical: sizes.large * 2 * scale,
                },
              ]}
            >
              <View style={[styles.rowLeft, condensed && { marginLeft: 0 }]}>
                {this.renderIcon(color, darkenedColor)}

                {this.renderText(dueIn)}
              </View>

              <View style={styles.rowRight}>{this.renderButtons(color)}</View>

              {this.renderParentIndicators()}
              {this.renderChildIndicators()}
              {this.renderAncestorIcons()}

              {showQuickActions && (
                <QuickActions
                  bar
                  value={value}
                  onUpdate={(updatedVal, newPrefs) => {
                    this.setState({ showQuickActions: false });
                    // !!onDeselect && onDeselect()
                    // !!onHideQuickActions && onHideQuickActions()
                    !!onUpdate && onUpdate(updatedVal, newPrefs);
                  }}
                  onClose={() => this.setState({ showQuickActions: false })}
                  onView={this.handleView}
                  onQuickEdit={() => this.setState({ showQuickEdit: true })}
                />
              )}
            </Animated.View>

            {this.props.renderFooter && this.props.renderFooter()}
          </View>
        </PlatformTouchable>

        {showTimeline && (
          <View style={{ paddingLeft: sizes.large }}>
            <TimelineNodes
              list
              value={value}
              condensed={condensed}
              noIcon={noIcon}
              scale={scale}
              iconScale={iconScale}
              minWidth={300}
            />
          </View>
        )}
      </View>
    );
  }

  renderQuickEdit = (value) => {
    return (
      <ValueInspector
        fullBleed
        value={value}
        onClose={() =>
          this.setState({ showQuickActions: false, showQuickEdit: false })
        }
      />
    );
  };

  handlePress = () => {
    let { onPress } = this.props;
    if (!!onPress) {
      onPress();
      return;
    }
    // this.handleView()
    if (this.state.showParents) {
      this.setState({ showParents: false });
    } else {
      this.setState({ showTimeline: !this.state.showTimeline });
    }
  };

  handleView = () => {
    let { value, onPress } = this.props;
    if (!!onPress) {
      onPress();
      return;
    }
    this.setState({ showQuickActions: false });
    let isFtuePrompt = typeof value.id == "string" && value.id.includes("ftue");
    if (isFtuePrompt) {
      let text = value.text.startsWith("Create a custom") ? "" : value.text;
      RootNavigation.navigate("Create", { ...value, text, ftue: true });
      return;
    }
    RootNavigation.push("Value", { id: value.id });
  };

  renderIcon = (valColor, emptyColor) => {
    let {
      value,
      onPressIcon,
      icon,
      iconColor,
      composingColor,
      scale,
      noIcon,
      iconScale,
    } = this.props;
    if (noIcon || iconScale == 0) return null;
    // let iconName = value.icon || value.rootIcon || icon
    let iconName = valueHelpers.getIcon(value) || icon;

    // let { color, opacity, } = valueHelpers.iconColor(value, valColor)
    // console.log(`valColor: ${valColor}, emtpy: ${emptyColor}, iconColor: ${color}`)
    let color = colorHelpers.modifyHex(emptyColor, 0.85);
    if (iconName == "spinner")
      return (
        <View style={{ width: sizes.itemHeight, height: sizes.itemHeight }}>
          <ActivityIndicator color={colors.lightForeground} />
        </View>
      );
    if (!!iconName)
      return (
        <TouchableOpacity
          style={{ alignSelf: "center" }}
          onPress={() => RootNavigation.push("Value", { id: value.id })}
        >
          <Icon
            onPress={onPressIcon}
            name={iconName}
            color={composingColor || iconColor || color}
            color={valColor}
            //color={emptyColor}
            //style={{opacity}}
            size={sizes.itemHeight * iconScale}
          />
          {!!value.id && (
            <ProgressRing
              value={value}
              color={color}
              color={valColor}
              modifyingColorBy={[colors.darkenBy, 0.85]}
              //color={valColor}
              selected={true}
              // emptyColor={colorHelpers.hexToRgbaString(ENV.DARK ? '#777' : '#ccc', 0.2)}
              //emptyColor={colorHelpers.modifyHex(emptyColor, 0.95)}
              emptyColor={emptyColor}
              size={sizes.itemHeight * 1.8 * iconScale}
              gutter={-sizes.itemHeight * 0.4 * iconScale}
              ignoreScreenRatio
            />
          )}
        </TouchableOpacity>
      );
  };

  renderText = (dueIn = null) => {
    let { value, renderText, noIcon, condensed, showDueDate } = this.props;
    if (noIcon) condensed = true;
    let { showTimeline } = this.state;
    let numberOfLines = showTimeline ? 99 : 1;

    let dueDateComp = this.renderDueDate(dueIn);
    let notePreview = this.renderNotePreview();

    let multiline = !!notePreview || (showDueDate && !!dueDateComp);

    return (
      <View
        style={[
          styles.textWrapper,
          condensed && { marginLeft: sizes.base },
          !!dueIn && dueIn > 0 && { opacity: 0.7 },
        ]}
      >
        {!!renderText ? (
          renderText()
        ) : (
          <Text
            style={[
              styles.text,
              multiline && styles.multilineText,
              !!dueIn && dueIn > 0 && { opacity: 0.7 },
            ]}
            numberOfLines={numberOfLines}
          >
            {!!value.notes?.length && (
              <FontAwesome
                name="file-text-o"
                style={[{ marginRight: 10 }, styles.text]}
              />
            )}
            {value.text}
          </Text>
        )}
        {dueDateComp}
        {notePreview}
      </View>
    );
  };

  renderDueDate = (dueIn) => {
    let { showDueDate, value } = this.props;
    if (!showDueDate || dueIn == null) return null;

    let dueStatus = frequencyHelpers.getStatus(dueIn, value);
    let dueString = frequencyHelpers.getDueString(dueIn, dueStatus, value);

    return (
      <Text
        // italic
        style={[
          styles.multilineText,
          {
            // position: 'absolute',
            // top: sizes.itemHeight,
          },
          // styles.text,
          { color: colors.lightForeground },
          { opacity: 0.5 },
          dueStatus == "upcoming" && { opacity: 0.5 },
          // dueStatus == 'overdue' && { color: 'red'},
          // dueStatus == 'overdue' && { opacity: 1},
        ]}
        numberOfLines={1}
      >
        {dueString}
      </Text>
    );
  };

  renderNotePreview = () => {
    let { value } = this.props;
    if (!!value.notes?.length) {
      // console.log(value.notes);
      let note = null;
      // let note = value.notes.find((n) => n.text.startsWith("7:"));
      if (!!note) {
        note = note.slice(note.indexOf(":") + 1);
        return (
          <Text
            style={[
              styles.multilineText,
              { color: colors.lightForeground },
              { opacity: 0.5 },
            ]}
            numberOfLines={1}
          >
            {note}
          </Text>
        );
      }
    }
    return null;
  };

  renderButtons = (color) => {
    let {
      value,
      iconColor,
      loading,
      hideButtons,
      renderButton,
      onCancel,
      onSubmit,
      customCancelButton,
      customSubmitButton,
      customIcon,
    } = this.props;

    let submitColor = iconColor || color || colors.foreground;

    if (loading) {
      return (
        <View style={styles.rowRight}>
          <ActivityIndicator color={colors.lightForeground} />
        </View>
      );
    }

    let cancelColor = colors.trim;
    cancelColor = colorHelpers.modifyHex(submitColor, 0.75);

    return (
      <View style={styles.rowRight}>
        {renderButton && renderButton(styles.icon)}
        {!hideButtons &&
          (!!customCancelButton ? (
            customCancelButton(styles.icon, cancelColor)
          ) : (
            <Feather
              name={"x"}
              color={cancelColor}
              style={styles.icon}
              onPress={onCancel}
            />
          ))}
        {(!hideButtons || !!customIcon) &&
          (!!customSubmitButton ? (
            customSubmitButton(styles.icon, submitColor)
          ) : this.state.loading ? (
            <ActivityIndicator color={colors.lightForeground} />
          ) : (
            <TouchableOpacity
              onPress={() => this.handleSubmit()}
              onLongPress={() => this.handleSubmit(true)}
            >
              {!!customIcon ? (
                customIcon(styles.icon)
              ) : (
                <Feather
                  name={"check"}
                  color={submitColor}
                  style={styles.icon}
                />
              )}
            </TouchableOpacity>
          ))}
      </View>
    );
  };

  renderParentIndicators = () => {
    let { value } = this.props;
    let parents = valueHelpers.getParents({ value });
    if (!!parents?.length) {
      return this.renderIndicators(parents, "left", false);
    }
  };

  renderChildIndicators = () => {
    let { value } = this.props;
    let children = valueHelpers.getChildren({ value });
    if (!!children?.length) {
      return this.renderIndicators(children, "right");
    }
  };

  renderIndicators = (family, position, includeIcon = false) => {
    // console.log(family)
    let width = sizes.small / 2;
    let style = {
      position: "absolute",
      top: sizes.small * 3,
      bottom: sizes.small * 3,
      width: sizes.small * 2.5,
    };
    // style[position] = (sizes.small*2) - width
    style[position] = 0;
    if (position == "right") style.paddingRight = sizes.small * 2;
    else style.paddingLeft = sizes.small * 2;

    family = family.reduce((r, a) => r.concat(a, 0), [0]).slice(1, -1);
    return (
      <TouchableOpacity
        style={style}
        onPress={() => {
          if (position == "left" && this.props.onPressLeft)
            this.props.onPressLeft();
          if (position == "right" && this.props.onPressRight)
            this.props.onPressRight();
        }}
      >
        <View
          style={{
            flex: 1,
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          {family.map((v, i) => {
            return (
              <View
                key={i}
                style={{
                  width: width,
                  borderRadius: sizes.small,
                  flex: !!v.id ? 1 : 0.5,
                  justifyContent: "center",
                  backgroundColor: !!v?.id
                    ? valueHelpers.getColor(v)
                    : "tranparent",
                }}
              >
                {includeIcon && !!v?.id && (
                  <Icon
                    name={valueHelpers.getIcon(v)}
                    color={valueHelpers.getColor(v)}
                    size={12}
                    style={styles.indicatorIcon}
                  />
                )}
              </View>
            );
          })}
        </View>
      </TouchableOpacity>
    );
  };

  renderAncestorIcons = () => {
    // if (!this.props.showAncestorIcons) return null;
    let { value } = this.props;
    let parents = valueHelpers.getParents({ value });
    if (!!parents?.length) {
      return (
        <TouchableOpacity
          style={styles.ancestorIconsRow}
          onPress={() =>
            this.setState({ showParents: !this.state.showParents })
          }
        >
          <View style={styles.ancestorIconsWrapper}>
            {parents.map((parent, i) => {
              if (i >= 3) return null;
              let color = valueHelpers.getColor(parent);
              // let rgbArray = colorHelpers.hexToRgb(color, true)
              // let boldColor = colorHelpers.saturate(rgbArray, 2)
              return (
                <Icon
                  key={i}
                  name={valueHelpers.getIcon(parent)}
                  color={color}
                  size={sizes.smallItemHeight}
                  style={{ marginLeft: sizes.small }}
                />
              );
            })}
          </View>
        </TouchableOpacity>
      );
    }
  };

  handleSubmit = async (longPress = false) => {
    await this.setState({ loading: true });
    this.props.onSubmit(longPress);
    // await this.setState({loading: false})
  };

  renderParents = (value) => {
    let parents = valueHelpers.getParents({ value });
    return (
      <View style={{ paddingLeft: sizes.large, paddingRight: sizes.large }}>
        <List
          ids={value.parent_ids}
          values={parents}
          // loading={loading}
          // onCancel={this.handle}
          hideButtons
          showDueDates
          showAncestorIcons
        />
      </View>
    );
  };
}

const styles = StyleSheet.create({
  wrapper: {
    // marginTop: sizes.base,
    borderRadius: sizes.small,
    // overflow: 'hidden',
  },
  row: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    paddingHorizontal: sizes.large + sizes.small * 2.5,
    overflow: "hidden",
  },
  rowLeft: {
    flex: 1,
    flexGrow: 1,
    flexShrink: 1,
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    marginLeft: sizes.base,
  },
  rowRight: {
    flexGrow: 0,
    flexShrink: 0,
    flexDirection: "row",
    justifyContent: "flex-end",
    alignSelf: "center",
  },
  icon: {
    marginLeft: sizes.large,
    width: sizes.itemHeight,
    fontSize: sizes.itemHeight,
  },
  textWrapper: {
    marginLeft: sizes.large + sizes.small,
    flex: 1,
  },
  text: {
    lineHeight: sizes.itemHeight,
    color: colors.lightForeground,
  },
  multilineText: {
    lineHeight: sizes.itemHeight * 0.7,
  },
  ancestorIconsRow: {
    position: "absolute",
    bottom: sizes.small,
    flexDirection: "row",
    justifyContent: "center",
    right: sizes.large - sizes.small + 1,
    width: (sizes.smallItemHeight + sizes.small) * 3 + sizes.small,
    // borderWidth: 3,
  },
  ancestorIconsWrapper: {
    flexShrink: 1,
    flexGrow: 1,
    flexDirection: "row",
    justifyContent: "flex-end",
    justifyContent: "center",
    paddingRight: sizes.small,
    paddingVertical: 2,
    borderRadius: sizes.small,
    backgroundColor: `rgba(0,0,0,0.25)`,
  },
  indicatorIcon: {
    position: "absolute",
    left: 4,
  },
});
